import type { AnyAction } from '@reduxjs/toolkit';
import type { Dispatch } from 'redux';

import {
  ALERT_BANNER_DEFAULT,
  GLOBAL_ALERT_BANNER_TYPES,
} from '../../../shared/constants';
import type { InvertedLocalize } from '../../../shared/hooks/use-invertedlocalize';
import { globalActions } from '../../../shared/store/globalSlice';
import type { AlertBannerState } from '../../../shared/types/globalTypes';

import { getQueryErrorHttpStatus } from './utils';

export interface ActivityLogMutationFailureBannerOptions {
  /** Used when HTTP status is not 403 */
  genericFailureTitle?: string;
  /** Used when HTTP status is not 403 */
  genericFailureDescription?: string;
}

/** Pushes a critical banner to `aag/global.alertBanner` (see `routes.tsx`). */
export function dispatchActivityLogMutationFailureBanner(
  dispatch: Dispatch<AnyAction>,
  error: unknown,
  l: InvertedLocalize<string>,
  options?: ActivityLogMutationFailureBannerOptions
): void {
  const httpStatus = getQueryErrorHttpStatus(error);
  const isForbidden = httpStatus === 403;

  const title = isForbidden
    ? l('Access Denied')
    : options?.genericFailureTitle ?? l('Review Failed');

  const description = isForbidden
    ? l(
        'You do not have permission to take any action. Request access from your administrator if you think this is a mistake.'
      )
    : options?.genericFailureDescription ??
      l('Something went wrong, please try again.');

  dispatch(
    globalActions.setGlobalAlertBanner({
      ...ALERT_BANNER_DEFAULT,
      kind: GLOBAL_ALERT_BANNER_TYPES.CRITICAL,
      title,
      description,
      isOpen: true,
    } as AlertBannerState)
  );
}
